import {
  orderMasterApi,
  orderStatusMasterApi,
  userMasterApi,
  userRoleApi,
} from '../admin/api/masterApi'
import { filterSellerUsers, userDisplayName } from '../admin/utils/userRoleFilters'

const API_BASE_URL = (
  process.env.REACT_APP_API_URL || 'https://api.trivomtara.com/api'
).replace(/\/$/, '')

function pad(n) {
  return String(n).padStart(2, '0')
}

/** Current local datetime for Order Master `order_datetime` (datetime-local). */
export function getNowOrderDateTime() {
  const now = new Date()
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
    now.getDate()
  )}T${pad(now.getHours())}:${pad(now.getMinutes())}`
}

export async function fetchOrderStatuses() {
  const rows = await orderStatusMasterApi.list()
  return rows || []
}

export async function resolveDefaultOrderStatusId() {
  const statuses = await fetchOrderStatuses()
  const preferred =
    statuses.find((row) =>
      /order\s*confirmed/i.test(String(row.order_status_name || ''))
    ) ||
    statuses.find((row) => /confirm/i.test(String(row.order_status_name || ''))) ||
    statuses[0]
  return preferred ? Number(preferred.order_status_id) : null
}

export async function fetchSellerOptions() {
  const [users, roles] = await Promise.all([
    userMasterApi.list(),
    userRoleApi.list(),
  ])
  return filterSellerUsers(users, roles).map((user) => ({
    value: Number(user.user_id),
    label: userDisplayName(user),
  }))
}

/**
 * Create marketplace order via Order Master API.
 * Payload matches admin Order Master fields.
 */
export async function createOrderMaster(payload) {
  return orderMasterApi.create(JSON.stringify(payload), { json: true })
}

/**
 * Orders placed by the logged-in buyer (Order Master rows for buyer_user_id).
 */
export async function fetchBuyerOrders(buyerUserId) {
  const userId = Number(buyerUserId)
  if (!Number.isFinite(userId) || userId <= 0) return []

  const rows = await orderMasterApi.list()
  return (rows || [])
    .filter((row) => Number(row.buyer_user_id) === userId)
    .sort((a, b) => {
      const dateA = new Date(a.order_datetime || 0).getTime()
      const dateB = new Date(b.order_datetime || 0).getTime()
      return dateB - dateA
    })
}

/** Legacy product_orders list used by admin Orders page */
export async function fetchOrders() {
  const res = await fetch(`${API_BASE_URL}/orders`)
  const data = await res.json()
  if (!res.ok || !data.success) {
    throw new Error(data.message || 'Failed to fetch orders')
  }
  return data.data
}

/** @deprecated Prefer createOrderMaster for storefront checkout */
export async function createOrder(payload) {
  return createOrderMaster(payload)
}

export function formatOrderAmount(value) {
  if (value == null || value === '') return ''
  return Number(value).toLocaleString('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  })
}

export function unitPriceFromProduct(product) {
  const list = product?.price != null ? Number(product.price) : 0
  const sale =
    product?.discount_price != null ? Number(product.discount_price) : null
  if (sale != null && Number.isFinite(sale) && sale < list) return sale
  return Number.isFinite(list) ? list : 0
}

export function discountFromProduct(product) {
  const list = product?.price != null ? Number(product.price) : 0
  const sale =
    product?.discount_price != null ? Number(product.discount_price) : null
  if (sale != null && Number.isFinite(sale) && sale < list) {
    return Math.max(0, list - sale)
  }
  return 0
}
